import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getPropertyState } from "../options";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { DataOptionsTypes } from "../types";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";

export const PropertyStatusFilter = ({ type }: { type: "checkbox" | "radio" }) => {
    const { country_code, translations } = useContext(ConfigStateContext);
    const { filters } = useFilters();
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();

    const propertiesStatus = getPropertyState(translations)
    const propertiesStatusByCountry = propertiesStatus.filter(status => status.countries.includes(country_code ? country_code.toUpperCase() : ""))
    const propertiesStatusList = propertiesStatusByCountry.map((status) => ({ text: status.text, value: status.value }))

    const handleRadioOnChange = (option: DataOptionsTypes) => {
        if (option.value !== -1) changeFilters({ constStatesID: [option] })
        else changeFilters({ constStatesID: [] })
    }

    const handleCheckboxOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentPropertiesStatusFilter = filters.constStatesID ?? []
        const { value, checked } = e?.target
        const parsedValue = Number(value)
        let updatedPropertiesStatusFilter = [];

        if (parsedValue === -1) {
            changeFilters({ constStatesID: [] });
        } else {
            if (checked) {
                updatedPropertiesStatusFilter = [...currentPropertiesStatusFilter, parsedValue];
            } else {
                updatedPropertiesStatusFilter = currentPropertiesStatusFilter.filter(b => b !== parsedValue);
            }

            const newPropertiesStatusFilter = propertiesStatusList.filter(item => updatedPropertiesStatusFilter.includes(item.value));

            changeFilters({ constStatesID: newPropertiesStatusFilter });
        }
    }

    return (
        <div className="otherFilters__container property-state-filter">
            <p>Estado</p>
            {type === "radio" ?
                propertiesStatusList.map((val, i) => {
                    return (
                        <div key={val.text + "-" + i} className="otherFilters__container__option">
                            <input
                                type="radio"
                                className="radioCustomInput"
                                onChange={() => handleRadioOnChange(val)}
                                name={"property-status-filter"}
                                id={`${val.text}-${val.value}`}
                                value={val.value ?? ""}
                                defaultChecked={
                                    filters?.constStatesID ?
                                        filters?.constStatesID.includes(val.value) :
                                        val.value === -1
                                }
                            />
                            <label htmlFor={`${val.text}-${val.value}`}>{val.text}</label>
                        </div>
                    )
                }) :
                propertiesStatusList.map((val, i) => {
                    return (
                        <div key={val.text + "-" + i} className="otherFilters__container__option" >
                            <input
                                type="checkbox"
                                className="checkBoxCustomInput"
                                onChange={handleCheckboxOnChange}
                                name={"property-status-filter"}
                                id={`${val.text}-${val.value}`}
                                value={val.value ?? ""}
                                checked={
                                    filters?.constStatesID &&
                                    filters?.constStatesID.includes(val.value)
                                }
                            />
                            <label htmlFor={val.text}>{val.text}</label>
                        </div>
                    )
                })
            }
        </div>
    )
}